import CheckoutWithHomeAddress from './CheckoutWithHomeAddress';
import CheckoutNoHomeAddress from './CheckoutNoHomeAddress';

const flows = {
    [CheckoutWithHomeAddress.name]: CheckoutWithHomeAddress,
    [CheckoutNoHomeAddress.name]: CheckoutNoHomeAddress,
};

export default flows;
